import { OPERATION_SYSTEM } from './consts'

export const getOperationSystem = (): string => {
  const clientInfoString = navigator.userAgent

  if (clientInfoString.includes('Windows')) {
    return OPERATION_SYSTEM.WINDOWS
  }

  if (isIOSDevice(clientInfoString)) {
    return OPERATION_SYSTEM.IOS
  }

  if (clientInfoString.includes('Mac')) {
    return OPERATION_SYSTEM.MAC_OS
  }

  if (clientInfoString.includes('X11') && !clientInfoString.includes('Linux')) {
    clientInfoString.includes('Mac')
    return OPERATION_SYSTEM.UNIX
  }

  if (clientInfoString.includes('X11') && clientInfoString.includes('Linux')) {
    return OPERATION_SYSTEM.LINUX
  }

  return ''
}

export const isIOSDevice = (
  userAgent: string = navigator.userAgent
): boolean => {
  const loweredUA = userAgent.toLowerCase()
  const isIOSMobile = /iphone|ipad|ipod/.test(loweredUA)
  const isIPadDesktop = loweredUA.includes('mac') && 'ontouchend' in document

  return isIOSMobile || isIPadDesktop
}

export const getIsOperationSystemMacOs = () =>
  getOperationSystem() === OPERATION_SYSTEM.MAC_OS
